import FeaturedLinks from "@/components/FeaturedLinks.vue";
import { strippedCta } from "@/helpers/builder-init/index";
export const featuredLinksInit = {
    component: FeaturedLinks,
    name: 'Featured Links',
    inputs: [
        {
            name: 'links',
            friendlyName: 'Links',
            type: 'array',
            subFields: [
                ...strippedCta(['url', 'aria_label', 'label', ]).subFields,
                {
                    name: 'caption',
                    friendlyName: 'Caption',
                    type: 'string',
                },
                {
                    name: "for_customer_type",
                    friendlyName: "For Customer Type",
                    type: "string",
                    enum: ['all', 'consumer', 'dealer'],
                }
            ]
        }
    ]
}